// extracted by mini-css-extract-plugin
export default {"container":"List_container__wTv-l","list":"List_list__AK7hC","list_social":"List_list_social__KLCGr","container_jc_end":"List_container_jc_end__BtOOm"};